export const EMPTY_STATE_BANNER_TITLE_TEXT = "activation.setup.empty.state.banner.title";
export const EMPTY_STATE_BANNER_SUB_TITLE_TEXT = "activation.setup.empty.state.banner.sub.title";
export const EMPTY_STATE_BANNER_BTN_TEXT = "activation.setup.empty.state.banner.button.text";
